import { LazyRouteFunction, NonIndexRouteObject } from 'react-router-dom';
import { isTestEnvironment } from '../../../../utils/isTestEnvironment';

export type NavigationConfig = {
  path: string;
  lazy?: LazyRouteFunction<NonIndexRouteObject>;
  isDev?: boolean;
};

export const officialAuthenticatedNavigationConfig: NavigationConfig[] = [
  // official routes
  {
    path: '/',
    lazy: async () => ({
      Component: (await import('../../../../pages/contracts/Contracts')).default,
    }),
  },
  // {
  //   path: '/dashboard/overview',
  //   lazy: async () => ({
  //     Component: (await import('../../../../pages/dashboard/Overview')).default,
  //   }),
  // },
  // {
  //   path: '/dashboard/insights',
  //   lazy: async () => ({
  //     Component: (await import('../../../../pages/dashboard/Insights')).default,
  //   }),
  // },
  {
    path: '/contracts',
    lazy: async () => ({
      Component: (await import('../../../../pages/contracts/Contracts')).default,
    }),
  },
  {
    path: '/contract/:contractId',
    lazy: async () => ({
      Component: (await import('../../../../pages/contracts/Contract')).default,
    }),
  },
  {
    path: '/projects',
    lazy: async () => ({
      Component: (await import('../../../../pages/projects/Projects')).default,
    }),
  },
  {
    path: '/project/:projectId',
    lazy: async () => ({
      Component: (await import('../../../../pages/projects/projectPage/ProjectPage')).default,
    }),
  },
  {
    path: '/orders',
    lazy: async () => ({
      Component: (await import('../../../../pages/order/Orders')).default,
    }),
  },
  {
    path: '/order/:orderId',
    lazy: async () => ({
      Component: (await import('../../../../pages/order/Order')).default,
    }),
  },
  {
    path: '/order/:orderId/interval/:intervalId',
    lazy: async () => ({
      Component: (await import('../../../../pages/intervals/Interval')).default,
    }),
  },
  {
    path: '/timereport',
    lazy: async () => ({
      Component: (await import('../../../../pages/timereport/TimeReportPage')).default,
    }),
  },
  {
    path: '/export/invoice',
    lazy: async () => ({
      Component: (await import('../../../../pages/invoice/Invoice')).default,
    }),
  },
  {
    path: '/export/salary',
    lazy: async () => ({
      Component: (await import('../../../../pages/salary/Salary')).default,
    }),
  },
  {
    path: '/case/management',
    lazy: async () => ({
      Component: (await import('../../../../pages/case/CaseManagement')).default,
    }),
  },
  {
    path: '/case/:caseId',
    lazy: async () => ({
      Component: (await import('../../../../pages/case/casePage/CasePage')).default,
    }),
  },
  {
    path: '/quality-control/management',
    lazy: async () => ({
      Component: (await import('../../../../pages/qualityControl/QualityControlManagement'))
        .default,
    }),
  },
  {
    path: '/quality-control/:qualityControlId',
    lazy: async () => ({
      Component: (
        await import('../../../../pages/qualityControl/qualityControlPage/QualityControlPage')
      ).default,
    }),
  },
  {
    path: '/articles/products',
    lazy: async () => ({
      Component: (await import('../../../../pages/articles/Products')).default,
    }),
  },
  {
    path: '/articles/services',
    lazy: async () => ({
      Component: (await import('../../../../pages/articles/Services')).default,
    }),
  },
  {
    path: '/customer/company',
    lazy: async () => ({
      Component: (await import('../../../../pages/customers/Companies')).default,
    }),
  },
  {
    path: '/customer/company/:companyId',
    lazy: async () => ({
      Component: (await import('../../../../pages/customers/Company')).default,
    }),
  },
  {
    path: '/customer/private',
    lazy: async () => ({
      Component: (await import('../../../../pages/customers/Individuals')).default,
    }),
  },
  {
    path: '/customer/private/:customerId',
    lazy: async () => ({
      Component: (await import('../../../../pages/customers/Individual')).default,
    }),
  },
  {
    path: '/resources/personnel',
    lazy: async () => ({
      Component: (await import('../../../../pages/resources/Employees')).default,
    }),
  },
  {
    path: '/resources/personnel/:employeeId',
    lazy: async () => ({
      Component: (await import('../../../../pages/resources/EmployeePage')).default,
    }),
  },
  {
    path: '/resources/vehicles',
    lazy: async () => ({
      Component: (await import('../../../../pages/resources/Vehicles')).default,
    }),
  },
  {
    path: '/resources/inventory',
    lazy: async () => ({
      Component: (await import('../../../../pages/resources/Inventory')).default,
    }),
  },
  {
    path: '/archive/documents',
    lazy: async () => ({
      Component: (await import('../../../../pages/archive/Archive')).default,
    }),
  },
  {
    path: '/resources/vehicles/:vehicleId',
    lazy: async () => ({
      Component: (await import('../../../../pages/resources/Vehicle')).default,
    }),
  },
  {
    path: '/templates/worktasks',
    lazy: async () => ({
      Component: (await import('../../../../pages/templates/workTasks/WorkTasks')).default,
    }),
  },
  {
    path: '/templates/attributes',
    lazy: async () => ({
      Component: (await import('../../../../pages/templates/attributes/AttributePage')).default,
    }),
  },
  {
    path: '/templates/priceadjustment',
    lazy: async () => ({
      Component: (await import('../../../../pages/templates/priceAdjustment/PriceAdjustments'))
        .default,
    }),
  },
  {
    path: '/templates/invoiceTemplates',
    lazy: async () => ({
      Component: (await import('../../../../pages/templates/invoiceTemplates/InvoiceTemplatesPage'))
        .default,
    }),
  },
  {
    path: '/settings/integrations',
    lazy: async () => ({
      Component: (await import('../../../../pages/settings/Settings')).default,
    }),
  },
  {
    path: '/settings/basic-settings',
    lazy: async () => ({
      Component: (await import('../../../../pages/settings/BasicSettingsPage')).default,
    }),
  },
  {
    path: '/settings/company-settings',
    lazy: async () => ({
      Component: (await import('../../../../pages/settings/CompanySettingsPage')).default,
    }),
  },
  {
    path: '/settings/license',
    lazy: async () => ({
      Component: (await import('../../../../pages/settings/License')).default,
    }),
  },
  {
    path: '/settings/employmentSchedule',
    lazy: async () => ({
      Component: (await import('../../../../pages/settings/EmploymentSchedule')).default,
    }),
  },
  {
    path: '/resource-planning/schedule',
    lazy: async () => ({
      Component: (await import('../../../../pages/resourcePlanning/ResourcePlanningSchedule'))
        .default,
    }),
  },
  {
    path: '/resource-planning/absences',
    lazy: async () => ({
      Component: (await import('../../../../pages/absences/AbsencesPage')).default,
    }),
  },
  // The changelog is only reachable locally and on the dev deployment, the same places the
  // sidebar links to it.
  ...(isTestEnvironment()
    ? [
        {
          path: '/changelog',
          lazy: async () => ({
            Component: (await import('../../../../pages/changelog/Changelog')).default,
          }),
        },
      ]
    : []),
];

export const devNavigationConfig: NavigationConfig[] = [
  {
    path: '/dev/address',
    lazy: async () => ({
      Component: (await import('../../../../pages/dev/address/AddressPage')).default,
    }),
    isDev: true,
  },
];
